import * as yup from 'yup';
import { validationRegex } from '../common';
import { type } from '@testing-library/user-event/dist/type';

export const ConjuntoColumnList = (isAdmin) => {
   return [
      {
         id: 'conjunto_id',
         dbname: 'id',
         label: 'id',
         visible: false,
         form: false,
         filter: true,
         align: 'right',
         type: 'number',
      },
      {
         id: 'conjunto_nombre',
         dbname: 'nombre',
         label: 'nombre',
         visible: true,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'conjunto_direccion',
         dbname: 'direccion',
         label: 'direccion',
         visible: true,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'conjunto_ciudad',
         dbname: 'ciudad',
         label: 'ciudad',
         visible: true,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'conjunto_departamento',
         dbname: 'departamento',
         label: 'departamento',
         visible: false,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'conjunto_pais',
         dbname: 'pais',
         label: 'pais',
         visible: false,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'conjunto_codigo_postal',
         dbname: 'codigo_postal',
         label: 'codigo_postal',
         visible: false,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'conjunto_estrato',
         dbname: 'estrato',
         label: 'estrato',
         visible: true,
         form: true,
         filter: true,
         align: 'right',
         type: 'number',
      },
      {
         id: 'conjunto_correo',
         dbname: 'correo',
         label: 'correo',
         visible: false,
         form: true,
         filter: true,
         type: 'string'
      },
      {
         id: 'conjunto_numero_apartamentos',
         dbname: 'numero_apartamentos',
         label: 'numero_apartamentos',
         visible: false,
         form: true,
         filter: true,
         align: 'right',
         type: 'number',
      },
      {
         id: 'conjunto_numero_casas',
         dbname: 'numero_casas',
         label: 'numero_casas',
         visible: false,
         form: true,
         filter: true,
         align: 'right',
         type: 'number',
      },
      {
         id: 'conjunto_tipo_parqueo',
         dbname: 'tipo_parqueo',
         label: 'tipo_parqueo',
         visible: false,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'conjunto_numero_parqueo_x_propiedad',
         dbname: 'numero_parqueo_x_propiedad',
         label: 'numero_parqueo_x_propiedad',
         visible: false,
         form: true,
         filter: true,
         align: 'right',
         type: 'number',
      },
      {
         id: 'conjunto_numero_parqueadero_motos',
         dbname: 'numero_parqueadero_motos',
         label: 'numero_parqueadero_motos',
         visible: false,
         form: true,
         filter: true,
         align: 'right',
         type: 'number',
      },
      {
         id: 'conjunto_numero_parqueadero_visitantes',
         dbname: 'numero_parqueadero_visitantes',
         label: 'numero_parqueadero_visitantes',
         visible: false,
         form: true,
         filter: true,
         align: 'right',
         type: 'number',
      },
      {
         id: 'conjunto_descripcion',
         dbname: 'descripcion',
         label: 'descripcion',
         visible: false,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'conjunto_telefono',
         dbname: 'telefono',
         label: 'telefono',
         visible: true,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'conjunto_sitio_web',
         dbname: 'sitio_web',
         label: 'sitio_web',
         visible: false,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'conjunto_fecha_creacion',
         dbname: 'fecha_creacion',
         label: 'fecha_creacion',
         visible: true,
         form: false,
         filter: false,
         type: 'datetime',
      },
      {
         id: 'conjunto_fecha_actualizacion',
         dbname: 'fecha_actualizacion',
         label: 'fecha_actualizacion',
         visible: false,
         form: false,
         filter: false,
         type: 'datetime',
      },
      {
         id: 'conjunto_total_coeficiente',
         dbname: 'total_coeficiente',
         label: 'total_coeficiente',
         visible: false,
         form: true,
         filter: false,
         align: 'right',
         type: 'number',
      },
      {
         id: 'conjunto_enlace_pago',
         dbname: 'enlace_pago',
         label: 'enlace_pago',
         visible: false,
         form: true,
         filter: false,
         type: 'string',
      },
      {
         id: 'conjunto_additional_info',
         dbname: 'additional_info',
         label: 'additional_info',
         visible: false,
         form: true,
         filter: false,
         type: 'json'
      }

   ];
};

export const ConjuntoValidationSchema = (t) => {
   return yup.object().shape({
      id: yup.number().nullable(),
      nombre: yup.string().required(t("not_emtpy_field")),
      direccion: yup.string().nullable(),
      ciudad: yup.string().nullable(),
      departamento: yup.string().nullable(),
      pais: yup.string().nullable(),
      codigo_postal: yup.string().nullable(),
      estrato: yup.number().nullable(),
      correo: yup.string().nullable().matches(validationRegex.mail, t("no_valid_mail")),
      numero_apartamentos: yup.number().nullable(),
      numero_casas: yup.number().nullable(),
      tipo_parqueo: yup.string().nullable(),
      numero_parqueo_x_propiedad: yup.number().nullable(),
      numero_parqueadero_motos: yup.number().nullable(),
      numero_parqueadero_visitantes: yup.number().nullable(),
      descripcion: yup.string().nullable(),
      telefono: yup.string().nullable(),
      sitio_web: yup.string().nullable(),
      fecha_creacion: yup.date().nullable(),
      fecha_actualizacion: yup.date().nullable(),
      total_coeficiente: yup.number().nullable(),

   });
};

export const ConjuntoFilterValidationSchema = (t) => {
   return yup.object().shape({
      id: yup.number().nullable(),
      nombre: yup.string().nullable(),
      direccion: yup.string().nullable(),
      ciudad: yup.string().nullable(),
      departamento: yup.string().nullable(),
      pais: yup.string().nullable(),
      codigo_postal: yup.string().nullable(),
      estrato: yup.number().nullable(),
      correo: yup.string().nullable(),
      numero_apartamentos: yup.number().nullable(),
      numero_casas: yup.number().nullable(),
      tipo_parqueo: yup.string().nullable(),
      numero_parqueo_x_propiedad: yup.number().nullable(),
      numero_parqueadero_motos: yup.number().nullable(),
      numero_parqueadero_visitantes: yup.number().nullable(),
      descripcion: yup.string().nullable(),
      telefono: yup.string().nullable(),
      sitio_web: yup.string().nullable(),
      fecha_creacion: yup.date().nullable(),
      fecha_actualizacion: yup.date().nullable(),
      total_coeficiente: yup.number().nullable(),

   });
};